/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TranslationServiceService {
    /**
     * Request a single or bulk message translation
     * @returns string Translation results
     * @throws ApiError
     */
    public static translateMessage({
        creatorId,
        language,
        userId,
        requestBody,
    }: {
        /**
         * Id of the creator.
         */
        creatorId: number,
        /**
         * Target language in ISO639-1 (2 Letter code like 'en' or 'de')
         */
        language: string,
        userId: number,
        /**
         * Array of Longs to be translated (max. 16)
         */
        requestBody: Array<number>,
    }): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/translation/{creatorId}/{userId}/translateMessage',
            path: {
                'creatorId': creatorId,
                'userId': userId,
            },
            query: {
                'language': language,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `No translation found for the given text
                `,
            },
        });
    }
    /**
     * Set the translation language parameter of a fan
     * @returns any OK
     * @throws ApiError
     */
    public static setLanguage({
        creatorId,
        userId,
        language,
    }: {
        /**
         * Id of the creator.
         */
        creatorId: number,
        /**
         * Id of the user
         */
        userId: number,
        /**
         * Translation language in ISO639-1 (2 Letter code like 'en' or 'de')
         */
        language: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/translation/{creatorId}/{userId}/setLanguage',
            path: {
                'creatorId': creatorId,
                'userId': userId,
            },
            query: {
                'language': language,
            },
        });
    }
    /**
     * Request a single or bulk raw text translation
     * @returns string Translation results
     * @throws ApiError
     */
    public static translate({
        creatorId,
        language,
        requestBody,
        initiationCause = '',
    }: {
        /**
         * Id of the creator.
         */
        creatorId: number,
        /**
         * Target language in ISO639-1 (2 Letter code like 'en' or 'de')
         */
        language: string,
        /**
         * Array of strings to be translated (max. 16)
         */
        requestBody: Array<string>,
        /**
         * Cause of translation (e.g. fan_message, chatter_message)
         */
        initiationCause?: string,
    }): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/translation/{creatorId}/translateText',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'initiationCause': initiationCause,
                'language': language,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `No translation found for the given text
                `,
            },
        });
    }
}
